import React, { useState, useEffect, useRef } from "react";
import classes from "./Header.module.css";
import ReactGA from "react-ga";
import ReactTooltip from "react-tooltip";
import ClickOutSideContext from "../Shared/ClickOutSide/ClickOutSideContext";
import ClickOutSide from "../Shared/ClickOutSide";
import { Urls } from "../../Urls";
import { withRouter } from "react-router-dom";
import { useAppContext, ContextConstants } from "../../Context/AppContext";
import firebase from "../../Firebase";
import Axios from "../../Axios";
import {
  Constants,
  Activity,
  ActivityString,
  currentRequestTimeStamp,
} from "../../Constants";
import { useMixPanelForTracking } from "../../shared_utilities/trackMixPanel";
import {
  hasValue,
  isValidBusinessEmail,
  isValidGSTNumber,
} from "../../Utility";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { Modal } from "../Shared/Modal/Modal";
import { ShareButton } from "./ShareButton";
import { useTransporterData } from "../../hooks/useTransporterData";
import { useCheckDuplicateTransporterName } from "../../hooks/useCheckDuplicateTransporterName";
import ProfileUpdateModal from "./ProfileUpdateModal";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { TbEdit, TbTruckFilled } from "react-icons/tb";
import { FaSave } from "react-icons/fa";
import { BiSolidChevronRight } from "react-icons/bi";
import { IoMdThumbsUp } from "react-icons/io";
import { IoShareSocialSharp } from "react-icons/io5";
import { HiEnvelope, HiUser } from "react-icons/hi2";
import { BsTelephoneFill } from "react-icons/bs";
import { TiArrowLeft } from "react-icons/ti";
import { MdMenu } from "react-icons/md";


// remove this - changes in lot of places
var transporter_code = "";

const Header = ({ history }) => {
  const { transporterInfo } = useAppContext();
  return (
    <div className={`shadow-sm ${classes["app-header"]}`}>
      <div>
        <button
          className={`pl-4 ${classes.logobutton}`}
          onClick={() => navigateTo(history, "/generalInfo")}
        >
          <img
            src={Urls.LorriLogoLogin}
            alt=""
            className={classes.logo_img}
          />
        </button>
      </div>

      {transporterInfo.account_type === "blocked" ? null : (
        <HeaderActions history={history} />
      )}
    </div>
  );
};

const HeaderActions = ({ history }) => {
 const { dispatch, transporterInfo, isEditable, validate, clientIp } =
  useAppContext();
  const [unreadMessages, setunreadMessages] = useState(0);
  const [showProfilePopUp, setShowProfilePopUp] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [showActions, setShowActions] = useState(true);
  const [showShareButton, setShowShareButton] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const dropDownRef = useRef(null);
  const [ispoc, setispoc] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showProfileUpdateModal, setShowProfileUpdateModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { refetch } = useTransporterData();
  const { TrackMixPanel } = useMixPanelForTracking();

  const { checkDuplicate } = useCheckDuplicateTransporterName();

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const clickOutside = (e) => {
    if (!dropDownRef?.current?.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // getUnreadMessages()
    transporter_code = transporterInfo?.profile_code;
    setShowSaveButton(
      history.location.pathname.toLowerCase() ===
      Constants.RoutePaths.ContractClosureInfo.toLowerCase()
    );
    setShowActions(isActionsOnPage(history.location.pathname));
  }, [history.location.pathname]);
  const getCurrentPath = () => history.location.pathname;

  useEffect(() => {
    if (
      transporterInfo.contact_information &&
      transporterInfo.contact_information.length > 0
    ) {
      transporterInfo.contact_information.map((item) => {
        if (
          item.poc === "yes" &&
          item.contact_number === transporterInfo?.user_details?.contact_number
        ) {
          setispoc(item.poc);
        }
      });
    }
  }, [transporterInfo]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", clickOutside);
    } else {
      document.removeEventListener("click", clickOutside);
    }
    return () => {
      document.removeEventListener("click", clickOutside);
    };
  }, [isOpen]);

  const checkRoute = (path) => {
    if (
      path === Constants.RoutePaths.GeneralInformation ||
      path === Constants.RoutePaths.ContractClosureInfo ||
      path === Constants.RoutePaths.BusinessProfile ||
      path === Constants.RoutePaths.OperationsOverview ||
      path === Constants.RoutePaths.CustomerDetails
    ) {
      return true;
    } else {
      if (isEditable) {
        alert("Please click on save button to proceed.");
        return false;
      } else {
        return true;
      }
    }
  };

  const history1 = useHistory();

  const navigate = () => {
    if (transporterInfo?.percentage_completion === 0) {
      alert("Please complete creating your LoRRI profile.");
      return history1.push("/generalInfo");
    } else {
      if (checkRoute("/access-control")) {
        history1.push("/access-control");
      }
    }
  };
  const onEdit = () => {
    Activity([
      {
        screen: getCurrentPath(),
        module: getCurrentPath(),
        user_activity: `${getCurrentPath()} ${ActivityString.Edit}`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    TrackMixPanel({
      ModuleName: "header",
      ScreenName: "transporter profile",
      Data: getCurrentPath(),
      Definition: "user has clicked on edit form button",
    });
    dispatch({
      type: ContextConstants.ToggleEdit,
    });
  };

  const onLoaderStateChange = () =>
    dispatch({
      type: ContextConstants.ToggleLoaderState,
    });

  const setNavigatingAway = (state) => {
    dispatch({
      type: ContextConstants.NavigatingAway,
      payload: state,
    });
  };

  const scrollTop = () => {
    document.getElementById("wizard-body").scrollTop = 0;
  };

  const hasDuplicates = (contact_info) => {
    const emails = new Set();
    const contactNumbers = new Set();

    return (
      contact_info.filter((contact) => {
        const { email, contact_number } = contact;
        if (emails.has(email) || contactNumbers.has(contact_number)) {
          return true;
        }
        emails.add(email);
        contactNumbers.add(contact_number);

        return false;
      }).length > 0
    );
  };

  const save = (path, next = false, callback) => {
    // ── Analytics ────────────────────────────────────────────────────────────────
    TrackMixPanel({
      ModuleName: "header",
      ScreenName: "transporter-profile",
      Data: getCurrentPath(),
      Definition: "user has clicked on save button",
    });

    // ── Client-side Validation ───────────────────────────────────────────────────
    const isValid = isPageValid(validate, transporterInfo, path);
    setNavigatingAway(!isValid);
    scrollTop();

    if (!isValid) {
      alert("Please resolve validation error(s)");
      return;
    }

    // ── Shared: Append current user to last_updated_by ───────────────────────────
    const appendLastUpdatedBy = () => {
      transporterInfo["last_updated_by"].push({
        contact_number: transporterInfo["user_details"]["contact_number"],
        timestamp: new Date().toISOString(),
      });
    };

    // ── Shared: POST transporter data and handle response ────────────────────────
    const postTransporterData = async () => {
      if (isSaving) return; // prevent duplicate calls

      setIsSaving(true);
      onLoaderStateChange();
      appendLastUpdatedBy();

      await Axios.post(Urls.Transporter.Post, transporterInfo)
        .then((r) => {
          if (r?.data?.percentage_completion) {
            dispatch({
              type: ContextConstants.updatePercentage,
              payload: r.data.percentage_completion,
            });
          }
          callback?.();
          refetch();
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setIsSaving(false);
          onLoaderStateChange();
        });
    };

    // ── Path: /generalInfo ───────────────────────────────────────────────────────
    if (path === "/generalInfo") {
      checkDuplicate(transporterInfo.transporter_name)
        .then((isDuplicate) => {
          if (isDuplicate) {
            toast.error("Transporter name already in use, please enter a different transporter name.");
            return;
          }

          // Validate net_profit entries
          if (transporterInfo?.net_profit?.length > 0) {
            const isNetProfitValid = transporterInfo.net_profit.every(
              (item) => item?.amount !== ""
            );
            if (!isNetProfitValid) {
              toast.error("Please enter valid net profit");
              return;
            }
          }

          // Normalize net_profit units and currency strings
          if (transporterInfo?.net_profit && transporterInfo?.turnover?.length > 0) {
            transporterInfo.net_profit.forEach((item) => {
              if (!item.unit) item.unit = "CR";
              if (item?.currency) {
                const i = item.currency.indexOf("(");
                if (i !== -1) item.currency = item.currency.slice(0, i).trim();
              }
            });
          }

          // Validate and normalize turnover entries
          if (transporterInfo?.turnover?.length > 0) {
            const isTurnoverValid = transporterInfo.turnover.every((item) => {
              if (!item.unit) item.unit = "CR";
              if (item?.currency) {
                const i = item.currency.indexOf("(");
                if (i !== -1) item.currency = item.currency.slice(0, i).trim();
              }
              return item?.amount !== "";
            });

            if (!isTurnoverValid) {
              toast.error("Please enter valid turnover");
              return;
            }
          }

          // Validate contact information
          if (transporterInfo?.contact_information?.length > 0) {
            if (hasDuplicates(transporterInfo.contact_information)) {
              alert("Duplicate email or contact_number found!");
              return;
            }

            // Warn user if they're removing their own contact number
            const userContactNumber = transporterInfo?.user_details?.contact_number;
            const isUserRemovingOwnContact = !transporterInfo.contact_information.some(
              (item) => item.contact_number === userContactNumber
            );

            if (isUserRemovingOwnContact) {
              const confirmed = window.confirm(
                `You are changing your own contact number. You will not be able to login to ` +
                `${transporterInfo.transporter_name} with ${userContactNumber} again. Are you sure you want to proceed?`
              );
              if (!confirmed) return;
            }

            postTransporterData();
          }
        })
        .catch((err) => console.log(err));

      // ── Path: /businessProfile ───────────────────────────────────────────────────
    } else if (path === "/businessProfile") {
      const isGSTInvalid =
        transporterInfo?.gst?.gst_registered === "yes" &&
        !isValidGSTNumber(transporterInfo?.gst?.gst_number);

      if (isGSTInvalid) {
        alert("Please enter a valid GST No.");
        return;
      }

      postTransporterData();

      // ── Path: /customerDetails ───────────────────────────────────────────────────
    } else if (path === "/customerDetails") {
      const hasEnoughReferences = transporterInfo.customer_reference.length >= 1;
      if (!hasEnoughReferences) {
        alert("Please enter atleast 3 references");
        return;
      }

      if (!isCustomerReferencesValid(transporterInfo)) {
        alert("Please resolve validation error(s)");
        return;
      }

      postTransporterData();

      // ── Path: All other routes ───────────────────────────────────────────────────
    } else {
      postTransporterData();
    }
  };

  const isCustomerReferencesValid = (transporterInfo) =>
    !transporterInfo.customer_reference ||
    !transporterInfo.customer_reference.length ||
    !transporterInfo.customer_reference.some(
      (c) =>
        !hasValue(c.name) ||
        !hasValue(c.contact_number) ||
        !hasValue(c.email) ||
        !isValidBusinessEmail(c.email) ||
        !hasValue(c.company_name)
    );

  const onSaveAndNext = () => {
    if (isSaving) return;

    save(history.location.pathname, true, () => {
      switch (history.location.pathname) {
        case Constants.RoutePaths.GeneralInformation:
          navigateTo(history, Constants.RoutePaths.BusinessProfile);
          break;
        case Constants.RoutePaths.BusinessProfile:
          navigateTo(history, Constants.RoutePaths.OperationsOverview);
          break;
        case Constants.RoutePaths.OperationsOverview:
          navigateTo(history, Constants.RoutePaths.CustomerDetails);
          break;
        case Constants.RoutePaths.CustomerDetails:
          navigateTo(history, Constants.RoutePaths.ContractClosureInfo);
          break;
        case Constants.RoutePaths.ContractClosureInfo:
          onEdit();
          navigateTo(history, Constants.RoutePaths.GeneralInformation);
          break;

        default:
          break;
      }
      TrackMixPanel({
        ModuleName: "header",
        ScreenName: "transporter-profile",
        Data: getCurrentPath(),
        Definition: "user has clicked on save and next button",
      });
    });
  };

  const onSave = () => {
    if (isSaving) return;
    save(history.location.pathname, false, onEdit)
  };

  const canEdit = () => {
    return (
      transporterInfo &&
      transporterInfo.user_details &&
      transporterInfo.user_details.poc &&
      transporterInfo.user_details.poc.toLowerCase() === Constants.Boolean.Yes
    );
  };

  const isOnEditablePages = () => {
    const editablePages = [
      "/businessProfile",
      "/operationsOverview",
      "/customerDetails",
      "/generalInfo",
      "/contract",
    ];
    for (let i = 0; i < editablePages.length; i++) {
      if (window.location.pathname === editablePages[i]) {
        return true;
      }
    }
    return false;
  };

  const showInterest = () => {
    if (transporterInfo?.percentage_completion === 0) {
      history.push({ pathname: "/generalInfo" });
    } else {
      history.push({ pathname: "/expression-of-interest" });
    }
  };

  const showPopUpTrucks = () => {
    if (isEditable) {
      alert("Please Click on save button to proceed");
    } else {
      history.push({ pathname: "/trucks" });
      TrackMixPanel({
        ModuleName: "header",
        ScreenName: "transporter-profile",
        Data: "none",
        Definition: "user has clicked trucks available button",
      });
    }
  };

  const showPopUpIndents = () => {
    if (isEditable) {
      alert("Please Click on save button to proceed");
    } else {
      history.push({ pathname: "/indents" });
      TrackMixPanel({
        ModuleName: "header",
        ScreenName: "transporter-profile",
        Data: "none",
        Definition: "user has clicked indents button",
      });
    }
  };

  const showSubscribe = () => {
    TrackMixPanel({
      ModuleName: "header",
      ScreenName: "transporter-profile",
      Data: "none",
      Definition: "user has clicked subscribe Now button",
    });
    Activity([
      {
        screen: "subscription",
        module: "subscribe_button",
        user_activity: `Header subscription button clicked`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    document.getElementById("subscribe_pop_up").style.display = "block";
  };

  const showSubscribe1 = () => {
    TrackMixPanel({
      ModuleName: "header",
      ScreenName: "transporter-profile",
      Data: "none",
      Definition: "user has clicked subscribe now button",
    });
    Activity([
      {
        screen: "subscription",
        module: "subscribe_button",
        user_activity: `Header subscription button clicked`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    document.getElementById("subscribe_pop_up1").style.display = "block";
  };

  const inMailClicked = () => {
    setunreadMessages(0);
    if (isEditable) {
      alert("Please Click on save button to proceed");
    } else {
      history.push({ pathname: "/enquiries" });
      TrackMixPanel({
        ModuleName: "header",
        ScreenName: "transporter-profile",
        Data: "none",
        Definition: "user has clicked on lorri mail button",
      });
    }
  };

  const handleShareButtonClick = () => {
    Activity([
      {
        screen: ActivityString.Header,
        module: "Header",
        user_activity: ActivityString.ShareButtonClicked,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    ReactGA.event({
      category: "TPMP",
      action: `${transporterInfo?.transporter_name
        },share button,,,TPMP, header, ${Date(24 * 3600 * 1000)}`,
    });
    setShowShareButton((prev) => !prev);
  };

  const closeShareButton = () => {
    setShowShareButton(false);
  };

  const logOutFunction = () => {
    TrackMixPanel({
      ModuleName: "header",
      ScreenName: "user profile",
      Data: {
        transporter_id: transporterInfo?.transporter_id,
        transporter_name: transporterInfo?.transporter_name,
        timeStamp: new Date().toISOString()
      },
      Definition: "user has clicked on the logout button.",
    });
    dispatch({
      type: ContextConstants.SetData,
      payload: {},
    });
    Activity(
      [
        {
          screen: "user profile",
          module: "lorriheader",
          user_activity: `Logged out successfully`,
          timestamp: currentRequestTimeStamp(),
        },
      ],
      "Sign-Out",
      transporterInfo.transporter_name,
      transporterInfo.transporter_id,
      clientIp,
      transporterInfo?.user_details?.contact_number
    );
    firebase.logout();
  };

  // Determine the subscribe handler based on policy group
  const handleSubscribe = transporterInfo.policy?.group !== "default"
    ? showSubscribe
    : showSubscribe1;

  return (
    <>
      <div className={classes.headerActions}>
        {showActions ? (
          <div className={classes.headerActionsContainer}>
            {!isEditable && canEdit() && isOnEditablePages() ? (
              <div className={`d-flex ${classes.headerActionsContainer}`}>
                <button
                  id="editButton"
                  onClick={onEdit}
                  className={`${classes.headerButton} ${classes.headerSuccessButton}`}
                >
                  <TbEdit size={15} />
                  <span className={classes["icon-button-text"]}>
                    Edit Profile
                  </span>
                </button>
                <button
                  onClick={() => setShowProfileUpdateModal(true)}
                  className={`${classes.headerButton} ${classes.headerSuccessButton} ${classes.iconButton}`}
                  title="Update Profile"
                >
                  <FaWandMagicSparkles size={14} />
                </button>
              </div>
            ) : null}

            {!showSaveButton && isEditable && isActionsOnPage && currentPath(history) ? (
              <button
                onClick={onSave}
                className={`${classes.headerButton} ${classes.headerSuccessButton}`}
                disabled={isSaving}
              >
                <FaSave size={15} />
                <span>Save</span>
              </button>
            ) : null}

            {isEditable && !showSaveButton && currentPath(history) ? (
              <button
                onClick={onSaveAndNext}
                className={`${classes.headerButton} ${classes.headerSuccessButton}`}
                disabled={isSaving}
              >
                <span>Save and Next</span>
                <BiSolidChevronRight size={15} />
              </button>
            ) : null}

            {showSaveButton &&
              isEditable &&
              history.location.pathname !== "/" ? (
              <button
                onClick={() => onSaveAndNext()}
                className={`${classes.headerButton} ${classes.headerSuccessButton}`}
                title="Submit Profile"
                disabled={isSaving}
              >
                <FaSave size={15} />
                <span>Submit</span>
              </button>
            ) : null}
          </div>
        ) : null}
      </div>

      {/* Mobile hamburger */}
      <button
        className={classes.hamburger}
        onClick={() => setMobileMenuOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
        <MdMenu size={24} />
      </button>

      {/* Desktop actions + Mobile drawer */}
      <div className={`${classes.headerUserProfileContainer} ${mobileMenuOpen ? classes.mobileMenuOpen : ""}`}>

        {/* <button
          onClick={showInterest}
          className={`${classes.headerButton} ${classes.headerSuccessButton}`}
        >
          <IoMdThumbsUp size={15} />
          <span>Upcoming Business</span>
        </button> */}

        {transporterInfo.policy ? (
          <button
            onClick={handleSubscribe}
            className={`${classes.headerButton} ${classes.headerPrimaryButton}`}
          >
            <span>Subscribe Now</span>
          </button>
        ) : (
          <button
            className={`${classes.headerButton} ${classes.headerPrimaryButton}`}
            onClick={showSubscribe1}
          >
            Subscribe Now
          </button>
        )}

        {transporterInfo.percentage_completion > "0" ? (
          <>
            <button
              onClick={showPopUpTrucks}
              className={`${classes.headerButton} ${classes.headerPrimaryButton}`}
            >
              <TbTruckFilled size={15} />
              <span>LoRRI Enquiries</span>
            </button>
            <button
              onClick={showPopUpIndents}
              className={`${classes.headerButton} ${classes.headerPrimaryButton}`}
            >
              <TbTruckFilled size={15} />
              <span>LoRRI Indents</span>
            </button>
          </>
        ) : null}

        {isProfileViewScreen(history.location.pathname) ? (<></>) : (
          <button
            onClick={() => navigateTo(history, "/generalInfo")}
            className={`${classes.headerButton} ${classes.headerPrimaryButton}`}
            title="Back to Profile"
          >
            <TiArrowLeft size={15} />
            <span>Back to Profile</span>
          </button>
        )}

        {showNotifications ? (
          <ClickOutSideContext.Provider
            value={{
              onClickOutSide: () => {
                setShowNotifications(false);
              },
            }}
          >
            <ClickOutSide>
              <NotificationsList />
            </ClickOutSide>
          </ClickOutSideContext.Provider>
        ) : null}

        <div className={classes.shareButtonWrapper}>
          <button
            data-tip
            data-for="shareProfile"
            onClick={handleShareButtonClick}
            className={`${classes.headerButton} ${classes.headerPrimaryButton} ${classes.iconButton}`}
          >
            <IoShareSocialSharp size={14} />
            <span className={classes.mobileOnlyLabel}>Share Profile</span>
            <ReactTooltip
              id="shareProfile"
              place="bottom"
              effect="solid"
              backgroundColor="#393185!important"
            >
              Share your Profile
            </ReactTooltip>
          </button>
          {showShareButton && transporterInfo?.profile_code && (
            <ShareButton
              transporter_name={transporterInfo.transporter_name}
              transporter_id={transporterInfo.transporter_id}
              transporter_code={transporterInfo?.profile_code}
              onClose={closeShareButton}
            />
          )}
        </div>

        {transporterInfo.percentage_completion > "0" ? (
          <span
            onClick={() => { inMailClicked(); }}
            data-tip
            data-for="lorriInMail"
            className={`${classes.headerButton} ${classes.headerPrimaryButton} ${classes.iconButton}`}
          >
            <HiEnvelope size={14} />
            <span className={classes.mobileOnlyLabel}>LoRRI Mail</span>
            {unreadMessages > 0 ? ` (${unreadMessages})` : ""}
          </span>
        ) : null}
        <ReactTooltip
          id="lorriInMail"
          place="bottom"
          effect="solid"
          backgroundColor="#393185!important"
        >
          {unreadMessages > 0
            ? `You have new enquiry update(s)!`
            : "LoRRI Mail "}
        </ReactTooltip>

        <button
          data-tip
          data-for="contactUS"
          onClick={() => setShowContactPopup(true)}
          className={`${classes.headerButton} ${classes.headerPrimaryButton} ${classes.iconButton}`}
        >
          <BsTelephoneFill size={14} />
          <span className={classes.mobileOnlyLabel}>Contact Us</span>
        </button>
        <ReactTooltip
          id="contactUS"
          place="bottom"
          effect="solid"
          backgroundColor="#393185!important"
        >
          Contact Us
        </ReactTooltip>

        <Modal
          show={showContactPopup}
          onClose={() => setShowContactPopup(false)}
          withHeader={true}
          overlayStyle={{ backgroundColor: "rgba(94, 94, 94, 0.28)" }}
          headerTitle="Have any questions or feedback? Reach out to us."
        >
          <div className="pt-3">
            <h6 className="text-center mb-3">
              <div className="mb-2 font-italics d-flex justify-content-between border-bottom pb-2">
                <strong>Phone Numbers:</strong>
                <p className="mb-1">+91-8928008311 / 9867773519</p>
              </div>
              <div className=" font-italics d-flex justify-content-between pt-1">
                <strong>Email:</strong>
                <a
                  href="mailto:connect@logisticsnow.in"
                  className="text-decoration-none"
                >
                  <p className="mb-0">connect@logisticsnow.in</p>
                </a>
              </div>
            </h6>
          </div>
        </Modal>

        <button
          ref={dropDownRef}
          onClick={toggleDropdown}
          className={`${classes.headerButton} ${classes.headerPrimaryButton} ${classes.iconButton} position-relative`}
        >
          <HiUser size={14} />
          <span className={classes.mobileOnlyLabel}>Account</span>
          {isOpen && <div className={classes.userDropdownOptionsContainer}>
            {ispoc && (
              <button
                className={classes.userDropdownOption}
                onClick={navigate}
              >
                Access Control
              </button>
            )}
            <button
              className={classes.userDropdownOption}
              onClick={() => logOutFunction()}
            >
              Logout
            </button>
          </div>}
        </button>
      </div>

      {/* Mobile overlay backdrop */}
      {mobileMenuOpen && (
        <div
          className={classes.mobileOverlay}
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Profile Update Modal */}
      <ProfileUpdateModal
        show={showProfileUpdateModal}
        onClose={() => setShowProfileUpdateModal(false)}
      />
    </>
  );
};

const currentPath = (history) => {
  return history.location.pathname !== "/";
};

const NotificationsList = () => {
  Activity([
    {
      screen: ActivityString.Header,
      module: "Notification",
      user_activity: ActivityString.NotificationButton,
      timestamp: currentRequestTimeStamp(),
    },
  ]);
  return (
    <div className={classes["user-profile-popup"]}>
      <div className={classes["user-profile-popup-userDetails"]}>
        <ul>
          <li>
            <b>Multi-million Business Opportunities from 50+ Companies!</b>
            <br />
          </li>
        </ul>
      </div>
    </div>
  );
};

const isPageValid = (validate, transporterInfo, pathname) => {
  let isValid = true;

  switch (pathname) {
    case Constants.RoutePaths.GeneralInformation:
      isValid = !validate.GeneralInfo || validate.GeneralInfo(transporterInfo);
      break;
    case Constants.RoutePaths.BusinessProfile:
      isValid =
        !validate.BusinessProfile || validate.BusinessProfile(transporterInfo);
      break;
    case Constants.RoutePaths.OperationsOverview:
      isValid =
        !validate.OperationsOverview ||
        validate.OperationsOverview(transporterInfo);
      break;
    case Constants.RoutePaths.CustomerDetails:
      isValid =
        !validate.CustomerDetails || validate.CustomerDetails(transporterInfo);
      break;
    case Constants.RoutePaths.ContractClosureInfo:
      isValid = !validate.Contract || validate.Contract(transporterInfo);

    default:
      break;
  }
  return isValid;
};

const navigateTo = (history, pathName) => {
  history.push({
    pathname: pathName,
  });
};

const navigateToWithState = (history, pathName, transporterInfo) => {
  history.push({
    pathname: pathName,
    state: transporterInfo,
  });
};

const isActionsOnPage = (currentPath) => {
  const restrictedPath = [
    "access-control",
    "ratecard",
    "ratecardeditable",
    "dashboard",
    "indents",
    "trucks",
    "RFQ",
    "dhandanow",
    "tender",
    "MyProfile",
    "expression-of-interest",
    "location-dashboard",
    "enquiries",
    "activeprocurement",
    "closedprocurement",
    "auction",
  ];
  let show = true;
  for (let i = 0; i < restrictedPath.length; i++) {
    if (currentPath.toLowerCase().includes(restrictedPath[i].toLowerCase())) {
      show = false;
      break;
    }
  }
  return show;
};

const isProfileViewScreen = (currentPath) => {
  const restrictedPath = ["MyProfile"];
  let show = true;
  for (let i = 0; i < restrictedPath.length; i++) {
    if (currentPath.toLowerCase().includes(restrictedPath[i].toLowerCase())) {
      show = false;
      break;
    }
  }
  return show;
};

export default withRouter(Header);